import { collection, getDoc, doc, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../firebase/firebase';
import { skipInDemoMode } from '../base/demoModeUtils';
import { toTimestamp } from '../../utilities/timestampUtils';
import { buildInviteLink, resolveValidInvite } from './projectNormalisers';

export async function createInviteLink(
  project_id: string,
  accessLevel: 'read' | 'write' | 'admin' = 'read'
): Promise<string | null> {
  const result = await skipInDemoMode(async () => {
    try {
      const inviteRef = await addDoc(collection(db, 'invites'), {
        project_id,
        accessLevel,
        createdAt: Timestamp.now(),
        expirationDate: toTimestamp(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000))!,
      });

      return buildInviteLink(inviteRef.id);
    } catch (error) {
      console.error('Error creating invite link:', error);
      return null;
    }
  });
  return result || null;
}

export async function validateInviteLink(
  inviteId: string
): Promise<{ project_id: string; accessLevel: string } | null> {
  try {
    const inviteDoc = await getDoc(doc(db, 'invites', inviteId));

    if (inviteDoc.exists()) {
      return resolveValidInvite(inviteDoc.data(), new Date());
    }

    return null;
  } catch (error) {
    console.error('Error validating invite link:', error);
    return null;
  }
}
